import type { IconName } from '@sparklayer-io/spark-dash-ui/components/ui/icon/types';
import { ExternalLink, Icon } from '@ui/themed';
import type { ReactNode } from 'react';

export function SectionTitle({
  icon = 'infoCircle',
  href,
  children,
}: {
  icon?: IconName;
  href: string;
  children: ReactNode;
}) {
  return (
    <div className="flex items-center gap-1">
      <Icon name={icon} size="md" />
      <ExternalLink link={href}>{children}</ExternalLink>
    </div>
  );
}
